import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {Puzzle, PuzzleConstants} from './puzzle.js';
import {vec3} from 'gl-matrix';
import {Mathf} from '../utils/Mathf.js';
import {Mathfx} from '../utils/mathFx.js';
import {Easing, lerp} from '../utils/lerp.js';

const tempVec3 = vec3.create();

export class WarningLine extends Component {
    static TypeName = 'warning-line';
    @property.float(0.6)
    offset = 0.6;

    @property.float(0.2)
    slideSpeedUp = 0.2;

    @property.float(0.2)
    slideSpeedDown = 0.2;

    @property.int(0)
    minRow = 0;

    @property.int(11)
    maxRow = 11;

    private _puzzle: Puzzle;
    private _lastHeight = 0;
    private _targetHeight = 0;
    private _startHeight = 0;
    private _step = -1;
    private _speed = 0;

    start() {
        this._puzzle = Puzzle.instance;

        this.object.getPositionWorld(tempVec3);
        tempVec3[1] = this.offset;
        this.object.setPositionWorld(tempVec3);
    }

    update(dt: number) {
        let maxHeight = 0;
        for (let x = 0; x < PuzzleConstants.columnCount; x++) {
            let row = this._puzzle.getHighestOccupiedRow(x);
            row = Mathf.clamp(row, this.minRow, this.maxRow);
            const height = this._puzzle.getRowOffset(row);
            if (height > maxHeight) {
                maxHeight = height;
            }
        }

        if (maxHeight != this._lastHeight) {
            this._targetHeight = maxHeight;
            if (this._targetHeight < maxHeight) {
                this._speed = this.slideSpeedDown;
            } else {
                this._speed = this.slideSpeedUp;
            }

            if (this._step < 0.0) {
                this._step = 0.0;
                this._startHeight = this._lastHeight;
            }
        }

        this._lastHeight = maxHeight;

        if (this._step >= 0.0) {
            this._step += dt * this._speed;
            let height = this._targetHeight;
            if (this._step >= 1.0) {
                this._step = -1.0;
            } else {
                height = lerp(
                    this._startHeight,
                    this._targetHeight,
                    this._step,
                    Easing.Hermite
                );
            }

            this.object.getPositionWorld(tempVec3);
            tempVec3[1] = height + this.offset;
            this.object.setPositionWorld(tempVec3);
        }
    }
}
